import { render, staticRenderFns } from "./CampaingEmailIndex.vue?vue&type=template&id=0476d74a"
import script from "./CampaingEmailIndex.vue?vue&type=script&lang=js"
export * from "./CampaingEmailIndex.vue?vue&type=script&lang=js"
import style0 from "./CampaingEmailIndex.vue?vue&type=style&index=0&id=0476d74a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports